import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import BoxList from 'modules/core/components/BoxList'

import type { Message } from 'modules/finance/hooks/useMessage'

interface Props {
  message: Message
}

const MessageAttachments = ({ message }: Props) => {
  const { fileNames } = message || {}

  if (!fileNames) return null

  return (
    <Box width="full" gap="s8">
      <Text.Normal weight="semibold">Attachments</Text.Normal>
      <Box paddingY="s6">
        <BoxList>
          {fileNames.map((filename, index) => (
            <Box
              alignItems="center"
              flexDirection="row"
              gap="s16"
              paddingY="s12"
              paddingX="s16"
              width="full"
              key={index}
            >
              <Box>
                <Icon.Medium icon="file" />
              </Box>
              <Box flexGrow>
                <Text size="200" weight="normal" ellipsis>
                  {filename}
                </Text>
              </Box>
            </Box>
          ))}
        </BoxList>
      </Box>
    </Box>
  )
}

export default MessageAttachments
